import { render, staticRenderFns } from "./ItemMail.vue?vue&type=template&id=e48e5c82"
import script from "./ItemMail.vue?vue&type=script&lang=js"
export * from "./ItemMail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports